import { SelectOptionProps } from '@/models/SelectOption';
import { UserType } from '@/models/User';
import { ApplicationStatus, ApplicationStatusesText } from '@/utils/constants';

export function buildStatusOptions(
  userType: UserType | null | undefined,
  currentStatus: number | undefined
): SelectOptionProps[] {
  if (userType == null || currentStatus == null) return [];

  const map: Record<number, ApplicationStatus[]> = {};

  if (userType === UserType.StateCoordinator) {
    Object.assign(map, {
      1: [ApplicationStatus.InProgress],
      9: [ApplicationStatus.InProgress, ApplicationStatus.Submitted],
    });
  } else if (userType === UserType.Adf) {
    Object.assign(map, {
      1: [ApplicationStatus.InProgress, ApplicationStatus.Closed],
      2: [
        ApplicationStatus.InProgress,
        ApplicationStatus.InRevision,
        ApplicationStatus.PendingRegionalReview,
      ],
      3: [
        ApplicationStatus.InProgress,
        ApplicationStatus.InRevision,
        ApplicationStatus.PendingRegionalReview,
        ApplicationStatus.PendingStateReview,
      ],
      4: [
        ApplicationStatus.InRevision,
        ApplicationStatus.PendingRegionalReview,
        ApplicationStatus.PendingStateReview,
        ApplicationStatus.PendingNationalReview,
        ApplicationStatus.PendingAdfReview,
        ApplicationStatus.Closed,
      ],
      5: [
        ApplicationStatus.InProgress,
        ApplicationStatus.InRevision,
        ApplicationStatus.PendingRegionalReview,
        ApplicationStatus.PendingStateReview,
        ApplicationStatus.PendingNationalReview,
        ApplicationStatus.PendingAdfReview,
        ApplicationStatus.Closed,
      ],
      6: [
        ApplicationStatus.InRevision,
        ApplicationStatus.PendingRegionalReview,
        ApplicationStatus.PendingStateReview,
        ApplicationStatus.PendingNationalReview,
        ApplicationStatus.PendingAdfReview,
        ApplicationStatus.ApplicationApproved,
      ],
      9: [ApplicationStatus.InProgress, ApplicationStatus.Submitted],
      11: [
        ApplicationStatus.InProgress,
        ApplicationStatus.InRevision,
        ApplicationStatus.PendingNationalReview,
        ApplicationStatus.PendingAdfReview,
      ],
    });
  }

  const available = map[currentStatus] ?? [];
  return available.map((v) => ({
    value: v.toString(),
    label: ApplicationStatusesText[v],
  }));
}
